import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ProjectService } from "@domain/project/project.service";
import { filter, Observable } from "rxjs";

@Component({
  selector: "app-toggle-lock-button",
  templateUrl: "./toggle-lock-button.component.html",
  styleUrl: "./toggle-lock-button.component.scss",
  imports: [UiKitModule],
  standalone: true,
})
export class ToggleLockButtonComponent {
  private projectService = inject(ProjectService);

  @Input({ required: true }) locked!: boolean;
  @Input() isSingleItem: boolean = false;
  @Output() toggleEvent = new EventEmitter<boolean>();

  protected readonly tooltipTextLockElement: string = $localize`:@@floorplan.button.lockCategory:Element sperren`;
  protected readonly tooltipTextUnlockElement: string = $localize`:@@floorplan.button.unlockCategory:Element entsperren`;
  protected readonly tooltipTextLockCategory: string = $localize`:@@floorplan.button.lockCategory:Kategorie sperren`;
  protected readonly tooltipTextUnlockCategory: string = $localize`:@@floorplan.button.unlockCategory:Kategorie entsperren`;
  protected hasWritePermission$: Observable<boolean | undefined>;

  constructor() {
    this.hasWritePermission$ = this.projectService.hasUserWritePermission$.pipe(
      filter((val): val is boolean => val !== undefined),
    );
  }
  toggleLock() {
    this.locked = !this.locked;
    this.toggleEvent.emit(this.locked);
  }

  setToolTipText() {
    if (this.isSingleItem) {
      return this.locked ? this.tooltipTextUnlockElement : this.tooltipTextLockElement;
    } else {
      return this.locked ? this.tooltipTextUnlockCategory : this.tooltipTextLockCategory;
    }
  }
}
